module.exports = __webpack_public_path__ + "static/media/ccsfp.logo.160w.e55b38af.png";